import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneThree = ({
  titleText = "Complete Growth Bundle",
  titleFont = "Poppins",
  titleFontSize = "48",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = false,
  titleIsItalic = false,
  titleIsUnderline = false,

  secondarySubtitleText = "Save 25% today.",
  secondarySubtitleFont = "Poppins",
  secondarySubtitleFontSize = "48",
  secondarySubtitleColor = "#FFFFFF",
  secondarySubtitleTextAlign = "center",
  secondarySubtitleIsBold = false,
  secondarySubtitleIsItalic = false,
  secondarySubtitleIsUnderline = false,

  subtitleText = "Save 25% today.",
  subtitleFont = "Poppins",
  subtitleFontSize = "48",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  buttonLabel = "Start Today",
  buttonFont = "Poppins",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "28",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#6B1B6B",

  backgroundType = "color",
  backgroundColor = "#8B88D8",
  backgroundImage = null,
  backgroundImagePreview,

  contentImageOne = null,
  contentImageOnePreview = null,

  inmeeting = false,
  preview = false,
  onClose,
  position = "left",
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-full" : isMobile ? "h-full" : "!h-[89vh] mt-[30%] w-72"
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto justify-between items-center p-4 md:p-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90 z-0"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Top Section */}
      <div className="relative z-10 flex flex-col justify-center items-center px-6 py-8 flex-shrink-0">
        {/* Main Heading */}
        <h1
          className={`mb-6 ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            fontFamily: titleFont,
            textAlign: titleTextAlign,
            lineHeight: "1.2",
            whiteSpace: "pre-line",
          }}
        >
          {titleText}
        </h1>

        {/* List Items */}
        <div className="flex flex-col gap-2 w-full">
          <h2
            className={`mb-6 ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: subtitleTextAlign,
              lineHeight: "1.2",
              whiteSpace: "pre-line",
            }}
          >
            {subtitleText}
          </h2>
        </div>
      </div>

      {/* Middle Section with Image */}
      <div className="relative z-10 flex flex-col justify-center items-center">
        {contentImageOne || contentImageOnePreview ? (
          <img
            src={
              contentImageOne instanceof File
                ? contentImageOnePreview
                : contentImageOne
            }
            alt="Product"
            className="max-w-full max-h-full object-contain"
            style={{ maxHeight: "300px" }}
          />
        ) : (
          <img
            src="/image_placeholder.png"
            alt="Product"
            className="w-full object-contain"
          />
        )}
      </div>

      {/* Bottom Section */}
      <div className="relative z-10 flex flex-col justify-center items-center px-6 py-8 flex-shrink-0">
        {/* Subtitle */}
        {secondarySubtitleText && (
          <p
            className={`mb-5 ${
              explicitBoleanCheck(secondarySubtitleIsBold) ? "font-bold" : ""
            } ${
              explicitBoleanCheck(secondarySubtitleIsItalic) ? "italic" : ""
            } ${
              explicitBoleanCheck(secondarySubtitleIsUnderline)
                ? "underline"
                : ""
            }`}
            style={{
              color: secondarySubtitleColor,
              fontSize: `${secondarySubtitleFontSize}px`,
              fontFamily: secondarySubtitleFont,
              textAlign: secondarySubtitleTextAlign,
            }}
          >
            {secondarySubtitleText}
          </p>
        )}
        {/* Button */}
        <button
          className={`px-2 py-2 md:px-4 md:py-2 rounded-md transition-all duration-200 shadow-lg hover:shadow-xl ${
            explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
          } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default VerticalTemplateOneOneThree;
